export const DEFAULT_GOOGLE_RECAPTCHA_GLOBAL_NAME = "grecaptcha";

export const getGoogleRecaptchaUrl = siteKey =>
	`https://www.google.com/recaptcha/api.js?render=${siteKey}`;
